import { createFileRoute } from '@tanstack/react-router'
import { QrControlPanel } from '@/components/qr/qr-control-panel'
import { ControlPanelSkeleton } from '@/components/shell/screen-skeletons'

/**
 * The panes only — no view bar.
 *
 * The bar is rendered by the parent route's `QrCodeShell`, which is already on
 * screen by the time this fallback shows. Drawing a `ViewBarSkeleton` here
 * stacked a grey second bar underneath the real one.
 */
export const Route = createFileRoute('/o/$org/qr-codes/$id/')({
  pendingComponent: ControlPanelSkeleton,
  component: QrControlPanelRoute,
})

function QrControlPanelRoute() {
  const { id } = Route.useParams()
  return <QrControlPanel constellationId={id} />
}
